import styled from 'styled-components'

import Link from 'components/Link'
import { TextLH } from 'styles/components/typography'

export const LinkStyled = styled(Link)`
  transition: opacity ${p => p.theme.animation.timeStandard};
  cursor: pointer;
  font-family: ${p => p.theme.typography.baseFont};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  opacity: 1;
  color: ${p => p.theme.colors.blackOp4};
  text-decoration: underline;

  ${p => p.theme.mq.hover} {
    &:hover,
    &.active {
      color: ${p => p.theme.colors.blackOp3};
      text-decoration: underline;
    }
  }
`

export const TextLHStyled = styled(TextLH)`
  font-family: ${p => p.theme.typography.baseFont};
  color: ${p => p.theme.colors.blackOp4};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;

  ${p => p.theme.mq.upMd} {
    font-size: 14px;
    line-height: 20px;
  }
`
